var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__a",
    width: 668,
    height: 699,
    x: 0,
    y: 0,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__b",
    width: 668,
    height: 699,
    x: 0,
    y: 0,
    rx: 14
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-368 -552)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H1440V1533H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170 325)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 667,
    height: 698,
    x: 0.5,
    y: 0.5,
    stroke: "#D9D9D9",
    rx: 14
  })), /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 44,
    x: 354.5,
    y: 539.5,
    stroke: "#8D8E97",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#8D8E97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "matrix(-1 0 0 1 386 553)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12L0 17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.df86a609f88fcc669457a2e4993bee86.svg";
export { ForwardRef as ReactComponent };